/**
 * L2-P1: moved to @miq/shared-models (helpers/catalog-switch.utils.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
export type { NavFeatureUpdate } from '@miq/shared-models';
export { featureNames } from '@miq/shared-models';
